import { useState, useEffect, useCallback } from 'react'
import { createFileRoute, useParams } from '@tanstack/react-router'
import { Container, Paper, Text, Stack } from '@mantine/core'
import { ResponsiveTitle } from '../../components/ResponsiveTitle/ResponsiveTitle'
import { RsvpForm } from '../../components/RsvpForm/RsvpForm'
import { useGuests } from '../../hooks/useGuests'
import { useSiteContent } from '@/hooks/useSiteContent'
import type { GuestWithDetails } from '../../lib/types'

export const Route = createFileRoute('/guest/logged_in/$pin/rsvp')({
  component: GuestRSVP,
})

function GuestRSVP() {
  const params = useParams({ from: '/guest/logged_in/$pin/rsvp' })
  const { getGuestByPin } = useGuests()
  const { content } = useSiteContent()

  const [guest, setGuest] = useState<GuestWithDetails | null>(null)
  const [loading, setLoading] = useState(true)

  const loadGuest = useCallback(async () => {
    setLoading(true)
    const guestData = await getGuestByPin(params.pin)
    if (guestData) {
      setGuest(guestData)
    }
    setLoading(false)
  }, [getGuestByPin, params.pin])

  useEffect(() => {
    loadGuest()
  }, [loadGuest])

  if (loading || !guest) {
    return null // Parent route handles loading/error states
  }

  const hasAdditionalGuests = (guest.additional_guests?.length || 0) > 0

  return (
    <Container size="lg" py="xl">
      <Paper shadow="xl" p="xl" bg="white">
        <Stack gap="xl">
          <ResponsiveTitle order={1} ta="center" c="golden">
            {content?.ui.Rückmeldung || 'Rückmeldung'}
          </ResponsiveTitle>
          <Text ta="center" size="md" c="dimmed">
            {hasAdditionalGuests
              ? content?.rsvp.descriptionMultiple ||
                'Teilt uns bitte mit, ob Ihr an unserer Hochzeit teilnehmen mögt.'
              : content?.rsvp.descriptionSingle ||
                'Bitte geben Sie uns Bescheid, ob Sie an unserer Hochzeit teilnehmen können.'}
          </Text>
          <RsvpForm guest={guest} onUpdate={loadGuest} />
        </Stack>
      </Paper>
    </Container>
  )
}
